import { graphql } from '../../../gql';

export const GET_CIRCLE = graphql(`
  query getCircle($id: ID!) {
    circle(id: $id) {
      ...CircleFields
      sharedStories {
        ...CircleStoryFields
      }
    }
  }
`);
